import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=265ae3ab&scoped=true"
import script from "./LinkCard.vue?vue&type=script&lang=js"
export * from "./LinkCard.vue?vue&type=script&lang=js"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=265ae3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265ae3ab",
  null
  
)

export default component.exports